require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-apollo-server-express.json") })
        }
      }, "path---package-bs-apollo-server-express");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-apollo-server-express!./.cache/json/package-bs-apollo-server-express.json
// module id = 756
// module chunks = 231608221292675